import { Box, Tab, Tabs } from "@mui/material";
import PagesContainer from "../../components/UI/PagesContainer";
import { useTranslation } from "react-i18next";
import { Button } from "@4uhub/lib4uhub";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { defaultScrollTheme } from "../../utils/utils";
import { TabPanel } from "../../components/TabPanel";
import TopMedSchedules from "../../components/TopMedSchedules/TopMedSchedules";
import { usePage } from "../../hooks/usePage";

const a11yProps = (index: number) => {
  return {
    id: `schedule-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const TRANSLATION_PATH = "page.topmedSchedule.mySchedules.";

const TopMedSchedule = () => {
  const [index, setIndex] = useState(0);

  const { t } = useTranslation();

  const { pageTitle } = usePage();

  const navigate = useNavigate();

  const handleChange = useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      setIndex(newValue);
    },
    []
  );

  const onClickHandler = () => {
    navigate("new");
  };

  return (
    <PagesContainer
      title={pageTitle || t(TRANSLATION_PATH + "title")}
      subtitle={t(TRANSLATION_PATH + "subtitle")!}
      redirectTo={"/schedule-teleconsultation"}
      rowActions={
        <Button variant="contained" onClick={onClickHandler}>
          {t(TRANSLATION_PATH + "add_button")}
        </Button>
      }
    >
      <Tabs value={index} onChange={handleChange}>
        <Tab label={t(TRANSLATION_PATH + "next")} {...a11yProps(0)} />
        <Tab label={t(TRANSLATION_PATH + "historic")} {...a11yProps(1)} />
      </Tabs>
      <Box
        height={"calc(100% - 48px)"}
        overflow={"auto"}
        sx={defaultScrollTheme}
      >
        <TabPanel index={0} value={index} sx={{ padding: 0, paddingRight: 1 }}>
          <TopMedSchedules />
        </TabPanel>
        <TabPanel index={1} value={index} sx={{ padding: 0, paddingRight: 1 }}>
          <TopMedSchedules historic />
        </TabPanel>
      </Box>
    </PagesContainer>
  );
};

export default TopMedSchedule;
